import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Junta classes condicionais resolvendo conflitos do Tailwind — a ultima
 *  utilitaria do mesmo grupo vence. Padrao shadcn/ui. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Data por extenso em pt-BR, como na referencia ("12 de maio de 2025"). */
export function formatLongDate(date: Date | string): string {
  // Uma string tipo "2026-08-01" (data civil, sem hora — o formato de
  // daily_records.date e das series de grafico) e interpretada pelo
  // JavaScript como meia-noite UTC. Formatar isso no fuso LOCAL do
  // navegador arrasta a data um dia para tras em qualquer fuso atras de UTC
  // (America/Sao_Paulo incluido) — o mesmo bug de fuso que o backend evita
  // com `freeze_tenant_date` nos testes. Forcar UTC aqui devolve a data
  // exata que a string representava. Um Date de verdade (ex.: `new Date()`,
  // "agora") continua no fuso local, que e o correto nesse caso.
  const isDateOnlyString = typeof date === "string";
  const value = isDateOnlyString ? new Date(date) : date;

  return new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: isDateOnlyString ? "UTC" : undefined,
  }).format(value);
}

/** Dia/mes curto para eixo de grafico (ex.: "01/08"). Recebe sempre uma data
 *  civil ("YYYY-MM-DD", nunca timestamp) — mesma correcao de fuso do
 *  `formatLongDate`, forcando UTC para nao arrastar um dia em fusos atras
 *  de UTC. */
export function formatShortDate(date: string): string {
  return new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", timeZone: "UTC" }).format(new Date(date));
}

/** Saudacao pelo horario. O app dos pais abre com ela (RF-04.1). */
export function greeting(now: Date = new Date()): string {
  const hour = now.getHours();
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}

/** Data civil ("YYYY-MM-DD") de N dias atras, usada pelo registro retroativo
 *  (RF-04.9). Monta a string a partir dos componentes LOCAIS (ano/mes/dia),
 *  nunca via `toISOString()`: isso converte para UTC e pode arrastar a data
 *  em fusos atras de UTC perto da meia-noite — o mesmo cuidado do
 *  `formatLongDate` acima, na direcao contraria (aqui construimos a string,
 *  la formatamos uma que ja existe). */
export function isoDateDaysAgo(days: number, from: Date = new Date()): string {
  const d = new Date(from);
  d.setDate(d.getDate() - days);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
